import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 26,
  medium: 20,
  small: 13,
  xSmall: 10
};
const MenuIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement("path", { d: "M5 7.5H25V8.5H5V7.5Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("path", { d: "M25 21.5H5V22.5H25V21.5Z", fill: "currentColor" })
  );
};
MenuIcon.iconName = "MenuIcon";

export { MenuIcon };
